// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3586":"6f354330c74c7aa3","7337":"d9a0665f5a572960"}[chunkId] + ".css";
};